const SET_ASSET_UPLOADING = 'scratch-gui/isAssetUploading/SET_ASSET_UPLOADING';

const initialState = {
    isAssetUploading: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_ASSET_UPLOADING:
        return Object.assign({}, state, {
            isAssetUploading: action.isAssetUploading
        });
    default:
        return state;
    }
};

const setAssetUploading = isAssetUploading => ({
    type: SET_ASSET_UPLOADING,
    isAssetUploading
});

export {
    reducer as default,
    initialState as isAssetUploadingInitialState,
    setAssetUploading
};
